import { Modal, Box, Button } from "@mui/material"
import {useNavigate } from "react-router-dom"
import {IModalProps } from "./props"


export const ModalEDSNotFound = ({open, handleClose}:IModalProps) => {
   const navigate = useNavigate()
    return (
        <Modal
            disableEscapeKeyDown
            open={open}
            sx={{
                backgroundColor: 'rgb(0,0,0, 0.1)',
                zIndex: 999999,
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'background.paper',

                    //width: '344px',
                    //maxHeight: '320px',
                    borderRadius: '4px',
                    border: 'none',
                    padding: '24px',

                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    gap: '24px',

                    '& h2': {
                        fontSize: '24px',
                        fontWeight: '600',
                        lineHeight: '28px',
                        color: '#3E3E3E',
                        //whiteSpace: 'nowrap',
                    },

                    '& p': {
                        fontSize: '16px',
                        fontWeight: '400',
                        color: '#3E3E3E',
                        lineHeight: '22px',
                    },
                }}
            >
                <Box
                    sx={{
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                    }}
                >
                    <h2>
                        ЭЦП не найдена
                    </h2>

                    <p>
                        Мы не смогли найти вашу ЭЦП.<br/>
                        Пожалуйста, проверьте все и<br/>
                        попробуйте снова, или воспользуйтесь<br/>
                        инструкцией по добавлению ЭЦП,<br/>
                        нажав кнопку «как добавить»
                    </p>
                </Box>

                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM36.0856 27.9132V48.3388C36.0856 50.5949 34.2566 52.4239 32.0005 52.4239C29.7443 52.4239 27.9154 50.5949 27.9154 48.3388V27.9132C27.9154 25.6571 29.7443 23.8281 32.0005 23.8281C34.2566 23.8281 36.0856 25.6571 36.0856 27.9132ZM32.0005 19.7431C34.2566 19.7431 36.0856 17.9142 36.0856 15.658C36.0856 13.4019 34.2566 11.5729 32.0005 11.5729C29.7443 11.5729 27.9154 13.4019 27.9154 15.658C27.9154 17.9142 29.7443 19.7431 32.0005 19.7431Z" fill="#FF4D4F"/>
                </svg>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '24px'
                    }}    
                >
                    <Button
                        onClick={()=>{
                            navigate('/documents')
                            handleClose()
                        }}
                        sx={{
                            width: '296px',
                            height: '36px',
                            backgroundColor: '#009FDA',
                            padding: '10px 12px',
                            borderRadius: '4px',
                            color: '#FFFFFF',
                            textTransform: 'none',
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '16px',
                            whiteSpace: 'nowrap',
                            '&:hover': {
                                backgroundColor: '#007FBA',
                            }
                        }}
                    >
                        К документам
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}